import {Injectable, Injector} from '@angular/core';
import {PesEventUtils, PesTaskService} from '@pes/ui';
import {Observable} from 'rxjs/Observable';
import {DocReadEnum} from '../../enum/doc-read.enum';


@Injectable()
export class UserActionTracerService {

    private readonly taskService: PesTaskService;

    private readonly READ_DOC_EVENT_REF: string = 'traceReadDocumentInContralia'
    private readonly CLICK_BUTTON_EVENT_REF: string = 'traceClickButtonInContralia'
    private readonly ACCEPT_CG_EVENT_REF: string = 'traceAcceptCgInContralia'

    constructor(injector: Injector) {
        this.taskService = injector.get(PesTaskService);
    }

    public traceReadDocumentAction(taskReference: string, transactionId: string, signatureId: string, documentName: string, docRead: DocReadEnum): Observable<any> {
        return this.taskService.sendMessage(taskReference, PesEventUtils.EVENT_REF, {
            event: this.READ_DOC_EVENT_REF,
            data: {
                docRead: docRead,
                transactionId: transactionId,
                userId: signatureId,
                documentName: documentName
            }
        });
    }

    public traceClickAction(taskReference: string, transactionId: string, signatureId: string, documentName: string, txtButton: string): Observable<any> {
        return this.taskService.sendMessage(taskReference, PesEventUtils.EVENT_REF, {
            event: this.CLICK_BUTTON_EVENT_REF,
            data: {
                transactionId: transactionId,
                userId: signatureId,
                documentName: documentName,
                txtButton: txtButton
            }
        });
    }

    public traceReadCgAction(taskReference: string, transactionsId: string, signatureId: string, agreementTexts: any): Observable<any> {
        return this.taskService.sendMessage(taskReference, PesEventUtils.EVENT_REF, {
            event: this.ACCEPT_CG_EVENT_REF,
            data: {
                transactionsId: transactionsId,
                userId: signatureId,
                agreementTexts: agreementTexts
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/service/user-action-tracer.service.ts